import hyRequest from '@/service'
import { IRequestResult } from '@/service/types'
import {
  IAggregateSaleData,
  IAggregateSaleDataParams,
  IAggregateSaleContrastData,
  IAggregateSaleTrendParams,
  IAggregateSaleTrend
} from './type'

enum DashboardApi {
  getAggregateSaleData = '/purchaseData/commercialPurchaseData',
  getAggregateSaleContrastData = '/purchaseData/commercialPurchaseContrastData',
  getAggregateSaleTrend = '/purchaseData/commercialPurchaseTrend'
}

// 骨料汇总及各料类销售数据
export function getAggregateSaleData(
  data: IAggregateSaleDataParams
): Promise<IRequestResult<IAggregateSaleData>> {
  return hyRequest.post<IRequestResult<IAggregateSaleData>>({
    url: DashboardApi.getAggregateSaleData,
    data
  })
}

//骨料销售对比数据
export function getAggregateSaleContrastData(
  data: IAggregateSaleDataParams
): Promise<IRequestResult<IAggregateSaleContrastData>> {
  return hyRequest.post<IRequestResult<IAggregateSaleContrastData>>({
    url: DashboardApi.getAggregateSaleContrastData,
    data
  })
}

export function getAggregateSaleTrend(
  data: IAggregateSaleTrendParams
): Promise<IRequestResult<IAggregateSaleTrend>> {
  return hyRequest.post<IRequestResult<IAggregateSaleTrend>>({
    url: DashboardApi.getAggregateSaleTrend,
    data: data
  })
}
